/* global axios */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  getStageStats(pipelineId) {
    return axios.get(`${this.baseUrl()}/${pipelineId}/stage_stats`);
  }

  // Pipeline Stages CRUD
  getStages(pipelineId) {
    return axios.get(`${this.baseUrl()}/${pipelineId}/pipeline_stages`);
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.baseUrl()}/${pipelineId}/pipeline_stages`, data);
  }

  updateStage(pipelineId, stageId, data) {
    return axios.patch(
      `${this.baseUrl()}/${pipelineId}/pipeline_stages/${stageId}`,
      data
    );
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(
      `${this.baseUrl()}/${pipelineId}/pipeline_stages/${stageId}`
    );
  }

  // Close Reasons CRUD
  getCloseReasons(pipelineId, stageType = null) {
    const params = stageType ? { stage_type: stageType } : {};
    return axios.get(`${this.baseUrl()}/${pipelineId}/close_reasons`, {
      params,
    });
  }

  createCloseReason(pipelineId, data) {
    return axios.post(`${this.baseUrl()}/${pipelineId}/close_reasons`, data);
  }

  updateCloseReason(pipelineId, reasonId, data) {
    return axios.patch(
      `${this.baseUrl()}/${pipelineId}/close_reasons/${reasonId}`,
      data
    );
  }

  deleteCloseReason(pipelineId, reasonId) {
    return axios.delete(
      `${this.baseUrl()}/${pipelineId}/close_reasons/${reasonId}`
    );
  }
}

export default new PipelinesAPI();
